import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import avatar from 'src/assets/images/technician.png';
import Page from 'src/components/Page';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}));

function Error404() {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page className={classes.root} title="Error 404">
      <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'}>
        The Page You Are Looking For Could Not Be Found!..
      </Typography>
      <Typography align="center" variant="subtitle2">
        You can access the Sirius login page with the button below
      </Typography>
      <div className={classes.imageContainer}>
        <img alt="Under development" className={classes.image} src={avatar} />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="outlined"
        >
          Sirius Login
        </Button>
      </div>
    </Page>
  );
}

export default Error404;
